/* ===== SPELL（SECRET）— 呪文ミス演出 =====
   1. モザイク崩壊（この間に GIF を裏で先読み＋実尺を計測）
   2. 黒画面にメッセージを 1 文字ずつ表示
   3. GAME OVER の GIF を全画面表示（実尺に合わせて静止画に差し替え）
   4. 戻りは演出なしで即 SPELL セクションへ

   ★GIF の実尺計測
      選ばれた GIF を fetch(force-cache) → ArrayBuffer で取り、
      GIF89a のブロック構造を歩いて Graphic Control Extension の
      delay（1/100 秒）を合算する。delay ≤ 1 はブラウザ慣習で 10cs 扱い。
      成功したら playMs = 実尺。失敗したら従来どおり設定値（data-mx-gifplay）。
      結果は __mxSpellDebug.gifDurationMs / parsedFrames / parseErr に出る。

   ★実尺から導く時刻（GIF 画面が開いてからの経過）
      安全キャプチャ : playMs - 350ms
      静止画差し替え : playMs - 50ms（ループ再開の直前）
      自動で戻る     : playMs + pauseMs
      操作ロック解除 : min(設定 lockMs, playMs - 200ms)

   ★静止画化のやり方（重なり順の事故を防ぐ）
   A) dataurl モード：控えたコマを PNG にして <img> の src ごと差し替える。
      同じ要素なので重なり順の問題が原理的に起きない。一番きれい。
      ※ canvas が汚染（cross-origin）していると toDataURL が例外を投げる。
   B) canvas モード（fallback）：キャンバスを最後の子に置いて上にかぶせ、
      <img> は display:none !important で完全に消す。
      （visibility:hidden だけだと他の CSS に負ける余地があった）

   ★安全キャプチャ：コマの控えは playMs の 350ms 手前で行う。
      GIF 末尾は CONTINUE? の静止ホールドなので見た目は変わらず、
      タイマーの揺らぎでループ点を跨いだ後のコマを掴む事故が起きない。

   ★診断値：window.__mxSpellDebug
   ・gifDurationMs / parsedFrames / parseErr / playSrc / captureAtMs / freezeAtMs
   ・frozen / frozenNow / freezeMode / freezeVia / freezeSkip / captureAt
   ・imgHidden（計算後 display）/ canvasZ / canvasRect / canvasParent

   ※ Escape はいつでも非常口として効く（ロック中でも）。 */
(function () {
  'use strict';
  if (window.__mxSpellFx) return;
  window.__mxSpellFx = true;

  var FAIL_TEXT = 'どうやら呪文を失敗したようだ……\n邪悪な霊気に囲まれてしまった……';
  var TYPE_SPEED = 35;
  var LINE_PAUSE_MS = 400;

  var WIPE_MS = 5000;
  var GIF_LOCK_MS = 7000;
  var GIF_PLAY_MS = 7700;
  var GIF_END_PAUSE_MS = 1500;
  var GIF_MAX_WAIT_MS = 8000;
  var WATCH_MS = 400;
  var CAPTURE_LEAD_MS = 350;   /* playMs のこの分手前でコマを控える */
  var BLACKOUT_MODE = true;    /* true: 再生終わりで <img> を消して真っ黒にする（コマ依存なし） */
  var FREEZE_LEAD_MS = BLACKOUT_MODE ? 0 : 50;  /* playMs のこの分手前で静止画へ／暗転は playMs 丁度 */
  var LOCK_MARGIN_MS = 200;    /* ロック解除は必ず playMs のこの分手前までに */
  var PARSE_MAX_BYTES = 8 * 1024 * 1024;  /* GIF 解析はここまでしか歩かない */
  var PARSE_MAX_BLOCKS = 20000;           /* ブロック数の上限（暴走防止） */
  var FREEZE_MAX_TRY = 6;
  var FREEZE_MAX_DPR = 2;
  var FREEZE_MAX_PX = 4096;
  var FREEZE_Z = '5';          /* .mx-spellfx__gif と兵弟より確実に上 */
  var MOSAIC_SIZES = [8, 16, 32, 64, 128];
  var MOSAIC_SUB = 3;

  /* ---------- 診断用 ---------- */
  var dbg = {
    version: 'spellfx-2026-08-21g',
    state: 'idle',
    reason: '',
    gifUrl: '',
    attrs: null,
    gifDurationMs: null, parsedFrames: null, parseErr: '',
    playSrc: '',          /* 'parsed'（実尺）| 'setting'（設定値フォールバック） */
    lockMs: null, playMs: null, pauseMs: null, totalMs: null,
    captureAtMs: null, freezeAtMs: null,
    revealAt: null, unlockAt: null, captureAt: null, freezeAt: null, returnAt: null, closeAt: null,
    elapsed: null,
    shown: false,
    frozen: false,        /* この回成功したか（履歴） */
    frozenNow: false,     /* 今静止画が出ているか */
    freezeMode: '',       /* 'dataurl' | 'canvas' */
    freezeVia: '',        /* 'timer' | 'watch' */
    freezeTries: 0, freezeGaveUp: false, freezeSkip: '',
    imgHidden: '', imgVisibility: '', imgRect: null,
    canvasParent: '', canvasZ: '', canvasRect: null, canvasIsLast: null,
    naturalW: null, naturalH: null,
    err: '', freezeErr: '',
    /* 実際に <img> が描いているコマの指紋（8x5 の輝度グリッド）を時刻つきで記録する。
       これを手元の GIF 各コマの同じ指紋と突き合わせれば、
       「その瞬間に何コマ目が出ていたか」が一意に determinable になる。 */
    trace: [], traceErr: '', imgLoadedAt: null, srcSetAt: null,
    /* 直前に「最後まで終わった回」の記録。次の回が始まっても消さない。
       いつでも copy(JSON.stringify(window.__mxSpellDebug.lastRun,null,2)) で取れる。 */
    lastRun: null,
    /* 呪文ログの送信結果 */
    logVia: '', logAt: null, logErr: '', logLen: null, logRes: ''
  };
  window.__mxSpellDebug = dbg;
  function stamp() { return new Date().toISOString().slice(11, 23); }
  function rectOf(node) {
    if (!node) return null;
    var r = node.getBoundingClientRect();
    return { x: Math.round(r.left), y: Math.round(r.top), w: Math.round(r.width), h: Math.round(r.height) };
  }

  function reduce() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function secretSection() {
    return document.querySelector('[data-mx-secret]') || document.querySelector('.mx-sec--secret');
  }
  function spellWrap() { return document.querySelector('.mx-spell'); }
  function spellInput() {
    var sp = spellWrap();
    return sp ? sp.querySelector('input') : null;
  }

  function failText() {
    var sec = secretSection();
    var raw = sec ? (sec.getAttribute('data-mx-failtext') || '') : '';
    raw = raw.replace(/<br\s*\/?>/gi, '\n').replace(/\r\n?/g, '\n');
    raw = raw.replace(/^\s+|\s+$/g, '');
    return raw || FAIL_TEXT;
  }

  function gifUrls() {
    var sec = secretSection();
    var raw = sec ? (sec.getAttribute('data-mx-gifs') || '') : '';
    var out = [];
    raw.split(',').forEach(function (s) {
      s = s.replace(/^\s+|\s+$/g, '');
      if (s) out.push(s);
    });
    return out;
  }
  function pickUrl() {
    var list = gifUrls();
    if (!list.length) return '';
    return list[Math.floor(Math.random() * list.length)];
  }

  function attrMs(name, fallback) {
    var sec = secretSection();
    var raw = sec ? sec.getAttribute(name) : null;
    if (raw === null || raw === '') return fallback;
    var n = parseFloat(raw);
    if (typeof n !== 'number' || !isFinite(n) || isNaN(n)) return fallback;
    if (n < 0) return fallback;
    var ms = Math.round(n * 1000);
    if (ms > 600000) return fallback;
    return ms;
  }
  function gifLockMs()  { return attrMs('data-mx-giflock',  GIF_LOCK_MS); }
  function gifPlayMs()  { return attrMs('data-mx-gifplay',  GIF_PLAY_MS); }
  function gifPauseMs() { return attrMs('data-mx-gifpause', GIF_END_PAUSE_MS); }

  function clearInput() {
    var inp = spellInput();
    if (inp) inp.value = '';
    var sp = spellWrap();
    if (sp) sp.classList.remove('has-text');
  }

  /* ---------- 正解判定 ---------- */
  function answerHash() {
    var sec = secretSection();
    var v = sec ? (sec.getAttribute('data-mx-answer') || '') : '';
    v = v.trim().toLowerCase();
    if (!v || v === 'none') return '';
    return v;
  }

  function sha256hex(str) {
    if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) return Promise.resolve('');
    var norm = str;
    try { norm = str.normalize('NFKC'); } catch (e) {}
    norm = norm.trim().toLowerCase();
    var buf = new TextEncoder().encode(norm);
    return window.crypto.subtle.digest('SHA-256', buf).then(function (d) {
      var a = new Uint8Array(d), out = '';
      for (var i = 0; i < a.length; i++) out += ('0' + a[i].toString(16)).slice(-2);
      return out;
    })['catch'](function () { return ''; });
  }

  /* ---------- スクロール ---------- */
  function lock() {
    document.documentElement.classList.add('mx-spellfx-lock');
    document.body.classList.add('mx-spellfx-lock');
  }
  function unlockScroll() {
    document.documentElement.classList.remove('mx-spellfx-lock');
    document.body.classList.remove('mx-spellfx-lock');
  }

  function jumpTo(node) {
    if (!node) return;
    var de = document.documentElement;
    var prevHtml = de.style.scrollBehavior;
    var prevBody = document.body.style.scrollBehavior;
    de.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';
    var y = node.getBoundingClientRect().top + (window.pageYOffset || de.scrollTop || 0);
    if (y < 0) y = 0;
    window.scrollTo(0, Math.round(y));
    de.style.scrollBehavior = prevHtml;
    document.body.style.scrollBehavior = prevBody;
  }

  /* ---------- 状態 ---------- */
  var ov = null, cvs = null, ctx = null, msg = null, msgBody = null, over = null, gif = null;
  var state = 'idle';
  var typeTimer = null, mosaicTimer = null, waitTimer = null;
  var lockTimer = null, freezeTimer = null, safetyTimer = null, autoTimer = null, watchTimer = null;
  var msgText = '';
  var overLocked = true;
  var overAt = 0;
  var wLock = 0, wPlay = 0, wTotal = 0;
  var freezeMaster = null, freezeView = null, preMaster = null;
  var freezeTries = 0, freezeGaveUp = false, frozenNow = false;

  var preImg = null, pendingUrl = '', gifReady = false, gifFailed = false;
  var revealed = false, warmed = false;
  var gifDurationMs = null;   /* 解析で得た実尺（ms）。null なら設定値を使う */

  /* ループ除去済みバイト列とその由来 URL、および毎回作り直す objectURL */
  var gifBytes = null, gifBytesUrl = '', gifObjUrl = '', revealSeq = 0;

  function setState(s) { state = s; dbg.state = s; }
  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }

  function buildOverlay() {
    ov = el('div', 'mx-spellfx');
    ov.setAttribute('aria-live', 'polite');
    ov.hidden = true;

    cvs = el('canvas', 'mx-spellfx__mosaic');
    cvs.setAttribute('aria-hidden', 'true');
    ov.appendChild(cvs);

    var stage = el('div', 'mx-spellfx__stage');

    msg = el('div', 'mx-spellfx__win mx-spellfx__msg');
    msg.setAttribute('role', 'dialog');
    msgBody = el('p', 'mx-spellfx__body');
    var nx = el('span', 'mx-spellfx__next');
    nx.textContent = '▼';
    msg.appendChild(msgBody);
    msg.appendChild(nx);
    stage.appendChild(msg);

    over = el('div', 'mx-spellfx__win mx-spellfx__over');
    over.setAttribute('role', 'dialog');
    gif = el('img', 'mx-spellfx__gif');
    gif.setAttribute('alt', '');
    gif.setAttribute('decoding', 'async');
    gif.setAttribute('loading', 'eager');
    gif.addEventListener('error', function () {
      dbg.err = 'img error @' + stamp();
      gif.style.visibility = 'hidden';
      if (state === 'over') {
        stopFreeze();
        overLocked = false;
        over.classList.add('is-ready');
      }
    });
    over.appendChild(gif);
    stage.appendChild(over);

    ov.appendChild(stage);
    document.body.appendChild(ov);

    msg.addEventListener('click', function (e) { e.stopPropagation(); advance(); });

    function overTap(e) {
      if (state !== 'over') return;
      e.preventDefault();
      e.stopPropagation();
      if (overLocked) return;
      close('tap');
    }
    over.addEventListener('pointerdown', overTap);
    over.addEventListener('click', overTap);
    gif.addEventListener('pointerdown', overTap);
    gif.addEventListener('click', overTap);

    ov.addEventListener('pointerdown', function () {
      if (state === 'over' && !overLocked) close('tap-ov');
    });
    ov.addEventListener('click', function () {
      if (state === 'msg') advance();
      else if (state === 'over' && !overLocked) close('tap-ov');
    });
  }

  /* ---------- GIF の実尺解析 ---------- */
  /* GIF89a のブロック構造を歩き、GCE の delay（1/100 秒）を合算する。
     ・ヘッダ 6 バイト + 論理スクリーン記述子 7 バイト + GCT（フラグがあれば）
     ・0x21 拡張：ラベル 0xF9（GCE）なら 4 バイトのサブブロック内の
       little-endian uint16 delay を読む。delay ≤ 1 はブラウザ慣習で 10cs。
     ・0x2C 画像記述子：9 バイト + LCT（フラグがあれば）+ LZW 最小コード長
       + データサブブロック列を飛ばす
     ・0x3B トレーラで終了
     失敗・異常構造なら null（呼び出し側が設定値にフォールバック）。 */
  function parseGifDuration(buf) {
    try {
      var u = new Uint8Array(buf);
      if (u.length < 14) return null;
      /* "GIF8" */
      if (u[0] !== 0x47 || u[1] !== 0x49 || u[2] !== 0x46 || u[3] !== 0x38) return null;
      var limit = Math.min(u.length, PARSE_MAX_BYTES);
      var p = 6;
      var packed = u[p + 4];             /* 論理スクリーン記述子のフラグ */
      p += 7;
      if (packed & 0x80) p += 3 * (1 << ((packed & 0x07) + 1));   /* GCT */
      var totalCs = 0, frames = 0, blocks = 0, sz;
      while (p < limit && blocks < PARSE_MAX_BLOCKS) {
        blocks++;
        var b = u[p++];
        if (b === 0x3B) break;           /* trailer */
        if (b === 0x21) {                /* extension */
          var label = u[p++];
          if (label === 0xF9 && p + 5 < limit && u[p] === 4) {
            var delay = u[p + 2] | (u[p + 3] << 8);   /* little-endian, 1/100s */
            if (delay <= 1) delay = 10;               /* ブラウザ慣習 */
            totalCs += delay;
          }
          while (p < limit) {            /* サブブロック列を飛ばす */
            sz = u[p++];
            if (sz === 0) break;
            p += sz;
          }
        } else if (b === 0x2C) {         /* image descriptor */
          frames++;
          var lp = u[p + 8];
          p += 9;
          if (lp & 0x80) p += 3 * (1 << ((lp & 0x07) + 1));   /* LCT */
          p++;                           /* LZW 最小コード長 */
          while (p < limit) {
            sz = u[p++];
            if (sz === 0) break;
            p += sz;
          }
        } else {
          return null;                   /* 未知ブロック＝壊れている */
        }
      }
      if (!frames || totalCs <= 0) return null;
      return { totalMs: totalCs * 10, frames: frames };
    } catch (e) {
      return null;
    }
  }

  /* GIF の NETSCAPE2.0 アプリケーション拡張（＝ループ指定）を丸ごと取り除く。
     再エンコードしないので画質・尺・コマ数は一切変わらない。
     これにより、素材側がループ設定のままアップロードされていても
     ブラウザは 1 回だけ再生して最終フレームで停止する。 */
  function stripGifLoop(u) {
    try {
      if (!u || u.length < 14) return u;
      var packed = u[10];
      var p = 13;
      if (packed & 0x80) p += 3 * (1 << ((packed & 0x07) + 1));
      var cuts = [], limit = u.length, blocks = 0, sz;
      while (p < limit && blocks < PARSE_MAX_BLOCKS) {
        blocks++;
        var start = p;
        var b = u[p++];
        if (b === 0x3B) break;
        if (b === 0x21) {
          var label = u[p++];
          var isLoop = (label === 0xFF && u[p] === 11 &&
                        u[p + 1] === 0x4E && u[p + 2] === 0x45 && u[p + 3] === 0x54 &&
                        u[p + 4] === 0x53 && u[p + 5] === 0x43 && u[p + 6] === 0x41 &&
                        u[p + 7] === 0x50 && u[p + 8] === 0x45);   /* "NETSCAPE" */
          while (p < limit) { sz = u[p++]; if (sz === 0) break; p += sz; }
          if (isLoop) cuts.push([start, p]);
        } else if (b === 0x2C) {
          var lp = u[p + 8];
          p += 9;
          if (lp & 0x80) p += 3 * (1 << ((lp & 0x07) + 1));
          p++;
          while (p < limit) { sz = u[p++]; if (sz === 0) break; p += sz; }
        } else {
          return u;   /* 未知ブロック＝触らない */
        }
      }
      if (!cuts.length) return u;
      var cut = 0, i;
      for (i = 0; i < cuts.length; i++) cut += cuts[i][1] - cuts[i][0];
      var out = new Uint8Array(u.length - cut), w = 0, read = 0;
      for (i = 0; i < cuts.length; i++) {
        out.set(u.subarray(read, cuts[i][0]), w);
        w += cuts[i][0] - read;
        read = cuts[i][1];
      }
      out.set(u.subarray(read), w);
      dbg.loopStripped = cuts.length;
      return out;
    } catch (e) {
      dbg.stripErr = String(e && e.message ? e.message : e);
      return u;
    }
  }

  /* reveal のたびに新しい objectURL を作る。
     同一 URL を再代入してもブラウザは走行中のアニメーションに乗るだけで
     先頭に戻らないため、必ず「別のリソース」にして再生を 0 から始めさせる。 */
  function freshGifSrc() {
    revealSeq++;
    if (gifBytes && gifBytesUrl === pendingUrl && window.URL && URL.createObjectURL) {
      try {
        if (gifObjUrl) { try { URL.revokeObjectURL(gifObjUrl); } catch (e2) {} }
        gifObjUrl = URL.createObjectURL(new Blob([gifBytes], { type: 'image/gif' }));
        dbg.srcMode = 'blob';
        return gifObjUrl;
      } catch (e) {
        dbg.srcMode = 'blob-failed:' + String(e && e.message ? e.message : e);
      }
    } else {
      dbg.srcMode = 'hash';
    }
    /* フォールバック：フラグメント違いで別リソース扱いにする（再取得はされない） */
    return pendingUrl + (pendingUrl.indexOf('#') >= 0 ? '' : '#mx' + revealSeq);
  }

  function measureGif(url) {
    gifDurationMs = null;
    gifBytes = null;
    gifBytesUrl = '';
    dbg.loopStripped = 0;
    dbg.stripErr = '';
    dbg.gifDurationMs = null;
    dbg.parsedFrames = null;
    dbg.parseErr = '';
    if (!url) { dbg.parseErr = 'no-url'; return; }
    if (!window.fetch || !window.Uint8Array) { dbg.parseErr = 'no-fetch'; return; }
    var mine = url;
    try {
      fetch(url, { cache: 'force-cache' }).then(function (res) {
        if (!res || !res.ok) throw new Error('http-' + (res ? res.status : '?'));
        return res.arrayBuffer();
      }).then(function (buf) {
        if (mine !== pendingUrl) return;   /* 別の回の結果は捨てる */
        try {
          gifBytes = stripGifLoop(new Uint8Array(buf));
          gifBytesUrl = mine;
        } catch (e3) {
          gifBytes = null; gifBytesUrl = '';
          dbg.stripErr = String(e3 && e3.message ? e3.message : e3);
        }
        var info = parseGifDuration(buf);
        if (info && info.totalMs > 0) {
          gifDurationMs = info.totalMs;
          dbg.gifDurationMs = info.totalMs;
          dbg.parsedFrames = info.frames;
        } else {
          dbg.parseErr = 'parse-failed';
        }
        /* 解析が reveal より遅れて届いたら、実尺でタイマーを引き直す */
        if (gifDurationMs && state === 'over' && revealed && !frozenNow && !freezeGaveUp) {
          deriveTimings();
          scheduleOverTimers();
        }
      })['catch'](function (e) {
        if (mine !== pendingUrl) return;
        dbg.parseErr = 'fetch: ' + String(e && e.message ? e.message : e);
      });
    } catch (e) {
      dbg.parseErr = String(e && e.message ? e.message : e);
    }
  }

  /* ---------- GIF の先読み ---------- */
  function preloadGif() {
    pendingUrl = pickUrl();
    gifReady = false;
    gifFailed = false;
    preImg = null;
    dbg.gifUrl = pendingUrl;

    if (!pendingUrl) { gifFailed = true; dbg.err = 'no gif url'; return; }

    measureGif(pendingUrl);   /* 裏で実尺を計測しておく */

    preImg = new Image();
    preImg.decoding = 'async';
    preImg.onload = function () {
      gifReady = true;
      if (state === 'over' && !revealed) showGifNow('preload-onload');
    };
    preImg.onerror = function () {
      gifFailed = true;
      dbg.err = 'preload error @' + stamp();
      if (state === 'over' && !revealed) revealFail();
    };
    preImg.src = pendingUrl;
    if (preImg.complete && preImg.naturalWidth > 0) gifReady = true;
  }

  function warmOne() {
    if (warmed) return;
    var u = pickUrl();
    if (!u) return;
    warmed = true;
    var w = new Image();
    w.decoding = 'async';
    w.src = u;
  }

  /* ---------- モザイク崩壊 ---------- */
  function sizeCanvas() {
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    cvs.width = vw;
    cvs.height = vh;
    ctx = cvs.getContext('2d');
  }

  function drawMosaic(size, cover) {
    if (!ctx) return;
    var w = cvs.width, h = cvs.height;
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#000';
    if (cover >= 1) { ctx.fillRect(0, 0, w, h); return; }
    for (var y = 0; y < h; y += size) {
      for (var x = 0; x < w; x += size) {
        if (Math.random() < cover) ctx.fillRect(x, y, size, size);
      }
    }
  }

  function fillBlack() {
    if (!ctx) return;
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, cvs.width, cvs.height);
  }

  function stopMosaic() { if (mosaicTimer) { clearTimeout(mosaicTimer); mosaicTimer = null; } }
  function stopWait()   { if (waitTimer)   { clearTimeout(waitTimer);   waitTimer = null; } }
  function stopLock()   { if (lockTimer)   { clearTimeout(lockTimer);   lockTimer = null; } }
  function stopFreeze() { if (freezeTimer) { clearTimeout(freezeTimer); freezeTimer = null; } }
  function stopSafety() { if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; } }
  function stopAuto()   { if (autoTimer)   { clearTimeout(autoTimer);   autoTimer = null; } }
  function stopWatch()  { if (watchTimer)  { clearInterval(watchTimer); watchTimer = null; } }
  function stopOverTimers() { stopLock(); stopFreeze(); stopSafety(); stopAuto(); stopWatch(); }

  function runMosaic(done) {
    if (reduce()) {
      ov.classList.add('is-flat');
      setTimeout(done, 60);
      return;
    }
    ov.classList.remove('is-flat');
    sizeCanvas();
    ctx.clearRect(0, 0, cvs.width, cvs.height);

    var frames = MOSAIC_SIZES.length * MOSAIC_SUB;
    var interval = WIPE_MS / frames;
    var k = 0;

    function tick() {
      var size = MOSAIC_SIZES[Math.floor(k / MOSAIC_SUB)];
      var cover = Math.pow((k + 1) / frames, 0.85);
      if (k === frames - 1) cover = 1;
      drawMosaic(size, cover);
      k++;
      if (k >= frames) { mosaicTimer = setTimeout(done, interval); return; }
      mosaicTimer = setTimeout(tick, interval);
    }
    tick();
  }

  /* ---------- メッセージ ---------- */
  function showWin(w) { w.classList.add('is-on'); }
  function hideWin(w) { w.classList.remove('is-on'); }
  function stopType() { if (typeTimer) { clearTimeout(typeTimer); typeTimer = null; } }

  function finishType() {
    stopType();
    msgBody.textContent = msgText;
    msg.classList.add('is-done');
  }

  function startMsg() {
    setState('msg');
    msg.classList.remove('is-done');
    msgText = failText();
    msgBody.textContent = '';
    showWin(msg);
    if (reduce()) { finishType(); return; }

    var i = 0;
    function step() {
      i++;
      msgBody.textContent = msgText.slice(0, i);
      if (i >= msgText.length) { finishType(); return; }
      var justTyped = msgText.charAt(i - 1);
      var wait = TYPE_SPEED + (justTyped === '\n' ? LINE_PAUSE_MS : 0);
      typeTimer = setTimeout(step, wait);
    }
    typeTimer = setTimeout(step, TYPE_SPEED);
  }

  function advance() {
    if (state !== 'msg') return;
    if (typeTimer) { finishType(); return; }
    startOver();
  }

  /* ---------- 静止画化 ---------- */
  /* 見えている <img> から現在コマを原寸で控える */
  /* 今 <img> が描画しているコマの指紋を取る（8x5 の輝度グリッド） */
  function traceGrid(tag) {
    try {
      if (!gif || !gif.naturalWidth) { dbg.trace.push({ t: overAt ? (Date.now() - overAt) : null, tag: tag, g: 'no-img' }); return; }
      var c = document.createElement('canvas');
      c.width = 8; c.height = 5;
      var x = c.getContext('2d');
      if (!x) return;
      x.drawImage(gif, 0, 0, 8, 5);
      var d = x.getImageData(0, 0, 8, 5).data, g = [], i;
      for (i = 0; i < 40; i++) {
        g.push(Math.round(d[i * 4] * 0.3 + d[i * 4 + 1] * 0.59 + d[i * 4 + 2] * 0.11));
      }
      dbg.trace.push({ t: overAt ? (Date.now() - overAt) : null, tag: tag, g: g.join(',') });
    } catch (e) {
      dbg.traceErr = String(e && e.message ? e.message : e);
    }
  }

  function captureMaster() {
    var nw = gif.naturalWidth, nh = gif.naturalHeight;
    dbg.naturalW = nw; dbg.naturalH = nh;
    if (!nw || !nh) return null;
    var m = document.createElement('canvas');
    m.width = nw;
    m.height = nh;
    var mx = m.getContext('2d');
    if (!mx) return null;
    mx.imageSmoothingEnabled = false;
    mx.drawImage(gif, 0, 0, nw, nh);
    return m;
  }

  /* 安全キャプチャ：playMs の CAPTURE_LEAD_MS 手前でマスターを控えておく。
     GIF 末尾は CONTINUE? の静止ホールドなので見た目の差はなく、
     タイマーの揺らぎでループ点を跨いだ後のコマを掴む事故が起きない。 */
  function doSafetyCapture() {
    if (BLACKOUT_MODE) return;   /* 暗転モードではコマを控える必要がない */
    if (state !== 'over' || !revealed || frozenNow || freezeGaveUp) return;
    if (!gif || !gif.complete) return;
    try {
      var m = captureMaster();
      if (m) {
        preMaster = m;
        dbg.captureAt = stamp();
        traceGrid('capture');
      }
    } catch (e) {
      dbg.freezeErr = 'preCapture: ' + String(e && e.message ? e.message : e);
    }
  }

  /* コンテナ（.mx-spellfx__over）の箱に合わせて contain で張る。
     ※ <img> は display:none にするので、測るのはコンテナ側。
        （.mx-spellfx__gif は width/height:100% なので箱は同じ） */
  function layoutFrozen() {
    if (!freezeView || !freezeMaster || !over) return;
    var r = over.getBoundingClientRect();
    var cw = r.width, ch = r.height;
    if (!cw || !ch) return;

    var dpr = window.devicePixelRatio || 1;
    if (dpr > FREEZE_MAX_DPR) dpr = FREEZE_MAX_DPR;
    var sw = Math.max(1, Math.round(cw * dpr));
    var sh = Math.max(1, Math.round(ch * dpr));
    var oversize = Math.max(sw / FREEZE_MAX_PX, sh / FREEZE_MAX_PX);
    if (oversize > 1) {
      sw = Math.max(1, Math.round(sw / oversize));
      sh = Math.max(1, Math.round(sh / oversize));
    }

    freezeView.width = sw;
    freezeView.height = sh;
    freezeView.style.setProperty('width', cw + 'px', 'important');
    freezeView.style.setProperty('height', ch + 'px', 'important');

    var vx = freezeView.getContext('2d');
    if (!vx) return;
    vx.imageSmoothingEnabled = false;
    vx.fillStyle = '#000';
    vx.fillRect(0, 0, sw, sh);

    var nw = freezeMaster.width, nh = freezeMaster.height;
    var scale = Math.min(sw / nw, sh / nh);
    var dw = Math.max(1, Math.round(nw * scale));
    var dh = Math.max(1, Math.round(nh * scale));
    var dx = Math.round((sw - dw) / 2);
    var dy = Math.round((sh - dh) / 2);
    vx.drawImage(freezeMaster, 0, 0, nw, nh, dx, dy, dw, dh);
  }

  function clearFrozen() {
    if (freezeView && freezeView.parentNode) freezeView.parentNode.removeChild(freezeView);
    freezeView = null;
    freezeMaster = null;
    preMaster = null;
    frozenNow = false;
    dbg.frozenNow = false;
    if (gif) {
      gif.style.removeProperty('display');
      gif.style.removeProperty('visibility');
    }
    if (over) over.style.removeProperty('background-color');
  }

  function resetFreezeStats() {
    freezeTries = 0;
    freezeGaveUp = false;
    preMaster = null;
    dbg.trace = [];
    dbg.traceErr = '';
    dbg.imgLoadedAt = null;
    dbg.srcSetAt = null;
    dbg.frozen = false;
    dbg.freezeTries = 0;
    dbg.freezeGaveUp = false;
    dbg.freezeSkip = '';
    dbg.freezeErr = '';
    dbg.captureAt = null;
    dbg.freezeAt = null;
    dbg.freezeMode = '';
    dbg.freezeVia = '';
    dbg.imgHidden = '';
    dbg.imgVisibility = '';
    dbg.imgRect = null;
    dbg.canvasParent = '';
    dbg.canvasZ = '';
    dbg.canvasRect = null;
    dbg.canvasIsLast = null;
  }

  /* 凍った後の実態を控える（重なり順の事故を自己申告させる） */
  function snapFreezeDiag() {
    try {
      if (gif) {
        var cs = window.getComputedStyle(gif);
        dbg.imgHidden = cs.display;
        dbg.imgVisibility = cs.visibility;
        dbg.imgRect = rectOf(gif);
      }
      if (freezeView) {
        var vs = window.getComputedStyle(freezeView);
        dbg.canvasZ = vs.zIndex;
        dbg.canvasRect = rectOf(freezeView);
        var p = freezeView.parentNode;
        dbg.canvasParent = p ? (p.tagName + '.' + (p.className || '')) : 'none';
        dbg.canvasIsLast = !!(p && p.lastElementChild === freezeView);
      }
    } catch (e) {}
  }

  function doFreeze(via) {
    if (frozenNow)        { dbg.freezeSkip = 'already-frozen'; return; }
    if (state !== 'over') { dbg.freezeSkip = 'state=' + state; return; }
    if (!revealed)        { dbg.freezeSkip = 'not-revealed'; return; }
    if (freezeGaveUp)     { dbg.freezeSkip = 'gave-up'; return; }
    if (!gif)             { dbg.freezeSkip = 'no-img-element'; return; }

    /* ---- 暗転モード ----
       コマを掴んで静止画に差し替える方式は「その瞬間に何コマ目が出ているか」に
       左右されるため、環境によってカウントダウン途中のコマが残ることがあった。
       再生の終わりで <img> をそのまま消し、真っ黒にしてから戻る。
       掴むコマが無いので、どんな環境でも結果が一定になる。 */
    if (BLACKOUT_MODE) {
      traceGrid('pre-blackout');
      gif.onload = null;
      gif.style.setProperty('display', 'none', 'important');
      gif.removeAttribute('src');
      if (over) over.style.setProperty('background-color', '#000', 'important');
      frozenNow = true;
      dbg.frozenNow = true;
      dbg.frozen = true;
      dbg.freezeMode = 'blackout';
      dbg.freezeVia = via || '';
      dbg.freezeAt = stamp();
      dbg.freezeSkip = '';
      dbg.freezeErr = '';
      snapFreezeDiag();
      return;
    }

    freezeTries++;
    dbg.freezeTries = freezeTries;
    if (freezeTries > FREEZE_MAX_TRY) {
      freezeGaveUp = true;
      dbg.freezeGaveUp = true;
      dbg.freezeSkip = 'max-try-exceeded';
      return;
    }
    if (!preMaster && !gif.complete) { dbg.freezeSkip = 'img-not-complete (try ' + freezeTries + ')'; return; }

    try {
      /* 安全キャプチャ済みならそれを使う（ループ点跨ぎの事故を回避）。
         なければ従来通り今のコマを控える。 */
      freezeMaster = preMaster || captureMaster();
      if (!freezeMaster) {
        dbg.freezeSkip = 'no-natural-size (try ' + freezeTries + ')';
        return;
      }

      /* --- A) 一番きれいな方法：<img> の二枚目を静止 PNG にする ---
         同じ要素を差し替えるので、重なり順の問題が原理的に起きない。
         canvas が汚染しているとここで例外になるので B）に落とす。 */
      try {
        traceGrid('pre-freeze');
        var png = freezeMaster.toDataURL('image/png');
        if (png && png.indexOf('data:image') === 0) {
          gif.onload = null;
          gif.src = png;
          frozenNow = true;
          dbg.frozenNow = true;
          dbg.frozen = true;
          dbg.freezeMode = 'dataurl';
          dbg.freezeVia = via || '';
          dbg.freezeAt = stamp();
          dbg.freezeSkip = '';
          dbg.freezeErr = '';
          snapFreezeDiag();
          return;
        }
      } catch (taint) {
        dbg.freezeErr = 'toDataURL: ' + String(taint && taint.name ? taint.name : taint);
        /* 汚染しているだけなので続行 */
      }

      /* --- B) fallback：キャンバスを一番上にかぶせ、<img> は完全に消す --- */
      var v = document.createElement('canvas');
      v.setAttribute('aria-hidden', 'true');
      v.style.setProperty('position', 'absolute', 'important');
      v.style.setProperty('top', '0', 'important');
      v.style.setProperty('right', '0', 'important');
      v.style.setProperty('bottom', '0', 'important');
      v.style.setProperty('left', '0', 'important');
      v.style.setProperty('margin', 'auto', 'important');
      v.style.setProperty('display', 'block', 'important');
      v.style.setProperty('z-index', FREEZE_Z, 'important');
      v.style.setProperty('image-rendering', 'pixelated', 'important');
      v.style.setProperty('pointer-events', 'auto', 'important');
      v.style.setProperty('touch-action', 'manipulation', 'important');
      v.style.setProperty('cursor', 'inherit', 'important');
      v.style.setProperty('user-select', 'none', 'important');

      freezeView = v;
      over.appendChild(v);      /* 必ず最後の子 */
      layoutFrozen();

      /* visibility だけだと他の CSS に負ける余地があるので display を !important で消す */
      gif.style.setProperty('display', 'none', 'important');

      v.addEventListener('pointerdown', function (e) {
        if (state === 'over' && !overLocked) { e.preventDefault(); e.stopPropagation(); close('tap-frozen'); }
      });
      v.addEventListener('click', function (e) {
        if (state === 'over' && !overLocked) { e.preventDefault(); e.stopPropagation(); close('tap-frozen'); }
      });

      frozenNow = true;
      dbg.frozenNow = true;
      dbg.frozen = true;
      dbg.freezeMode = 'canvas';
      dbg.freezeVia = via || '';
      dbg.freezeAt = stamp();
      dbg.freezeSkip = '';
      snapFreezeDiag();
    } catch (err) {
      dbg.freezeErr = String(err && err.message ? err.message : err);
      dbg.freezeSkip = 'threw';
      if (freezeView && freezeView.parentNode) freezeView.parentNode.removeChild(freezeView);
      freezeView = null;
      freezeMaster = null;
      frozenNow = false;
      dbg.frozenNow = false;
      if (gif) {
        gif.style.removeProperty('display');
        gif.style.removeProperty('visibility');
      }
    }
  }

  function doUnlock() {
    if (state !== 'over') return;
    if (!overLocked) return;
    overLocked = false;
    over.classList.add('is-ready');
    dbg.unlockAt = stamp();
  }

  function doAutoReturn() {
    if (state !== 'over') return;
    dbg.returnAt = stamp();
    close('auto');
  }

  /* ---------- タイマーの実効値を導く ----------
     playMs：解析成功なら GIF の実尺、失敗なら設定値（従来どおり）。
     lockMs：設定値を min(設定, playMs - 200ms) にクランプ
             （ロック解除が再生時間を超えられないように）。 */
  function deriveTimings() {
    var playSetting = gifPlayMs();
    if (gifDurationMs && gifDurationMs > 0) {
      wPlay = gifDurationMs;
      dbg.playSrc = 'parsed';
    } else {
      wPlay = playSetting;
      dbg.playSrc = 'setting';
    }
    var lockSetting = gifLockMs();
    wLock = (wPlay > 0) ? Math.min(lockSetting, Math.max(0, wPlay - LOCK_MARGIN_MS)) : lockSetting;
    wTotal = wPlay + gifPauseMs();

    dbg.lockMs = wLock;
    dbg.playMs = wPlay;
    dbg.pauseMs = wTotal - wPlay;
    dbg.totalMs = wTotal;
    dbg.captureAtMs = wPlay > 0 ? Math.max(0, wPlay - CAPTURE_LEAD_MS) : null;
    dbg.freezeAtMs = wPlay > 0 ? Math.max(0, wPlay - FREEZE_LEAD_MS) : null;
  }

  /* overAt 起点でタイマーを（引き）直す。reveal 直後にも、
     解析結果が遅れて届いたときにも使う。 */
  function scheduleOverTimers() {
    stopOverTimers();
    var elapsed = Date.now() - overAt;

    if (overLocked) {
      if (wLock > 0 && elapsed < wLock) {
        over.classList.remove('is-ready');
        lockTimer = setTimeout(doUnlock, wLock - elapsed);
      } else {
        overLocked = false;
        over.classList.add('is-ready');
        if (!dbg.unlockAt) dbg.unlockAt = stamp();
      }
    }

    if (wPlay > 0 && !frozenNow && !freezeGaveUp) {
      var capAt = Math.max(0, wPlay - CAPTURE_LEAD_MS);
      var frzAt = Math.max(0, wPlay - FREEZE_LEAD_MS);
      safetyTimer = setTimeout(doSafetyCapture, Math.max(0, capAt - elapsed));
      freezeTimer = setTimeout(function () { doFreeze('timer'); }, Math.max(0, frzAt - elapsed));
    }
    if (wTotal > 0) autoTimer = setTimeout(doAutoReturn, Math.max(0, wTotal - elapsed));
    watchTimer = setInterval(watchTick, WATCH_MS);
  }

  function watchTick() {
    if (state !== 'over') { stopWatch(); return; }
    var elapsed = Date.now() - overAt;
    dbg.elapsed = elapsed;
    if (dbg.trace.length < 26) traceGrid('t');
    if (wLock > 0 && overLocked && elapsed >= wLock) doUnlock();
    if (wPlay > 0 && !preMaster && !frozenNow && !freezeGaveUp && elapsed >= Math.max(0, wPlay - CAPTURE_LEAD_MS)) doSafetyCapture();
    if (wPlay > 0 && !frozenNow && !freezeGaveUp && elapsed >= Math.max(0, wPlay - FREEZE_LEAD_MS)) doFreeze('watch');
    if (wTotal > 0 && elapsed >= wTotal) doAutoReturn();
  }

  /* ★GIF を見せる唯一の入口 */
  function showGifNow(reason) {
    if (revealed) return;
    revealed = true;
    stopWait();

    overAt = Date.now();
    overLocked = true;
    deriveTimings();

    dbg.reason = reason;
    dbg.revealAt = stamp();
    dbg.shown = false;
    resetFreezeStats();

    scheduleOverTimers();

    try {
      gif.style.removeProperty('display');
      gif.style.removeProperty('visibility');
      gif.removeAttribute('src');
      gif.onload = function () { dbg.imgLoadedAt = Date.now() - overAt; traceGrid('loaded'); };
      gif.src = freshGifSrc();
      dbg.srcSetAt = Date.now() - overAt;
      preImg = null;   /* 先読み側の走行中タイムラインを手放す */
      dbg.shown = true;
      dbg.playSeq = revealSeq;
    } catch (e) {
      dbg.err = 'show: ' + String(e && e.message ? e.message : e);
    }
  }

  /* ---------- GAME OVER 画面 ---------- */
  function startOver() {
    setState('over');
    hideWin(msg);

    revealed = false;
    overLocked = true;
    stopWait();
    stopOverTimers();
    clearFrozen();
    resetFreezeStats();
    over.classList.remove('is-ready');
    gif.style.setProperty('visibility', 'hidden');
    showWin(over);

    var sec = secretSection();
    dbg.attrs = sec ? {
      giflock: sec.getAttribute('data-mx-giflock'),
      gifplay: sec.getAttribute('data-mx-gifplay'),
      gifpause: sec.getAttribute('data-mx-gifpause')
    } : null;

    if (gifFailed || !pendingUrl) { revealFail(); return; }

    if (gifReady || (preImg && preImg.complete && preImg.naturalWidth > 0)) {
      showGifNow('ready');
      return;
    }

    waitTimer = setTimeout(function () {
      waitTimer = null;
      if (state === 'over' && !revealed) showGifNow('max-wait');
    }, GIF_MAX_WAIT_MS);
  }

  function revealFail() {
    if (revealed) return;
    revealed = true;
    stopWait();
    stopOverTimers();
    clearFrozen();
    gif.removeAttribute('src');
    gif.style.setProperty('visibility', 'hidden');
    overLocked = false;
    over.classList.add('is-ready');

    overAt = Date.now();
    wLock = 0;
    wPlay = 0;
    wTotal = gifPlayMs() + gifPauseMs();
    dbg.reason = 'fail';
    dbg.revealAt = stamp();
    dbg.totalMs = wTotal;
    dbg.freezeSkip = 'gif-failed';
    if (wTotal > 0) autoTimer = setTimeout(doAutoReturn, wTotal);
    watchTimer = setInterval(watchTick, WATCH_MS);
  }

  /* ---------- 終了 ---------- */
  /* 1 回分の記録を固定化する（次の回の reset で消えないように） */
  function snapshotRun(why) {
    try {
      if (!dbg.revealAt) return;   /* GIF 画面まで行っていない回は残さない */
      dbg.lastRun = {
        why: why,
        version: dbg.version,
        gifUrl: dbg.gifUrl,
        gifDurationMs: dbg.gifDurationMs,
        parsedFrames: dbg.parsedFrames,
        parseErr: dbg.parseErr,
        playSrc: dbg.playSrc,
        srcMode: dbg.srcMode || '',
        playSeq: dbg.playSeq || null,
        loopStripped: dbg.loopStripped,
        playMs: dbg.playMs, pauseMs: dbg.pauseMs, totalMs: dbg.totalMs,
        captureAtMs: dbg.captureAtMs, freezeAtMs: dbg.freezeAtMs,
        srcSetAt: dbg.srcSetAt, imgLoadedAt: dbg.imgLoadedAt,
        revealAt: dbg.revealAt, captureAt: dbg.captureAt, freezeAt: dbg.freezeAt,
        frozen: dbg.frozen, freezeMode: dbg.freezeMode, freezeVia: dbg.freezeVia,
        freezeTries: dbg.freezeTries, freezeSkip: dbg.freezeSkip, freezeErr: dbg.freezeErr,
        naturalW: dbg.naturalW, naturalH: dbg.naturalH,
        elapsed: dbg.elapsed,
        traceErr: dbg.traceErr,
        trace: dbg.trace.slice(0)
      };
    } catch (e) {}
  }

  function close(reason) {
    if (state === 'out' || state === 'idle') return;
    snapshotRun('close:' + (reason || ''));
    setState('out');
    dbg.closeAt = stamp();
    dbg.reason = (dbg.reason || '') + ' > close:' + (reason || '');
    stopType();
    stopMosaic();
    stopWait();
    stopOverTimers();
    clearFrozen();
    overLocked = true;
    revealed = false;
    over.classList.remove('is-ready');
    hideWin(msg);
    hideWin(over);
    clearInput();
    unlockScroll();
    var target = secretSection();
    jumpTo(target);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        jumpTo(target);
        ov.hidden = true;
        ov.classList.remove('is-flat');
        if (ctx) ctx.clearRect(0, 0, cvs.width, cvs.height);
        setState('idle');
        var inp = spellInput();
        if (inp) {
          try { inp.focus({ preventScroll: true }); } catch (e) {}
        }
      });
    });
  }

  function start() {
    if (state !== 'idle') return;
    if (!secretSection()) return;
    if (!ov) buildOverlay();
    var inp = spellInput();
    if (inp) inp.blur();
    lock();
    setState('wipe');
    overLocked = true;
    revealed = false;
    stopWait();
    stopOverTimers();
    clearFrozen();
    resetFreezeStats();
    over.classList.remove('is-ready');
    gif.style.setProperty('visibility', 'hidden');
    hideWin(msg);
    hideWin(over);
    msgBody.textContent = '';
    ov.hidden = false;

    dbg.err = '';
    dbg.revealAt = null;
    dbg.unlockAt = null;
    dbg.returnAt = null;
    dbg.closeAt = null;
    dbg.elapsed = null;

    preloadGif();

    runMosaic(function () {
      mosaicTimer = null;
      if (state !== 'wipe') return;
      startMsg();
    });
  }

  /* ---------- 入力の判定 ---------- */
  /* ---------- 呪文の入力ログ ----------
     送信先（Google スプレッドシートの Apps Script Web App URL）は
     SECRET セクションの設定から data-mx-logurl として渡ってくる。
     空なら何も送らない。演出を止めないよう常に投げっぱなしにする。 */

  function cut(v, max) {
    v = String(v == null ? '' : v);
    return (max && v.length > max) ? v.slice(0, max) : v;
  }

  function logUrl() {
    var sec = secretSection();
    var u = sec ? (sec.getAttribute('data-mx-logurl') || '') : '';
    return u.replace(/^\s+|\s+$/g, '');
  }

  function sessionId() {
    try {
      var k = 'mxSpellSid';
      var v = window.sessionStorage.getItem(k);
      if (!v) {
        v = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
        window.sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return ''; }
  }

  function queryParam(name) {
    try {
      var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search || '');
      return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
    } catch (e) { return ''; }
  }

  function logAttempt(value, ok) {
    var url = logUrl();
    if (!url) return;
    var payload = {
      value: String(value == null ? '' : value),
      ok: ok ? 1 : 0,
      locale: (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '',
      device: (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ? 'mobile' : 'desktop',
      ua: navigator.userAgent || '',
      referrer: document.referrer || '',
      utm_source: queryParam('utm_source'),
      utm_medium: queryParam('utm_medium'),
      utm_campaign: queryParam('utm_campaign'),
      path: window.location.pathname || '',
      sid: sessionId()
    };
    /* ---- 送信方法について ----
       検証で分かったこと：
       ・sendBeacon(POST)  … PC 成功 / モバイル不可。ページ離脱用のAPIで、
         Apps Script のクロスドメイン・リダイレクトを追わない実装がある。
       ・フォーム POST     … 400。ナビゲーション扱いなので Google の Cookie を
         全部送ってしまい、その肥大が原因の可能性が高い。
       ・画像 GET          … データが URL に載る。Cookie も送るため、
         複数 Google アカウントのときの /u/N 書き換えでエラーになる。
       ・fetch(no-cors)    … PC 成功。ただし応答が不透明で、
         成功も失敗も見分けられない（status は常に 0）。

       Content-Type: text/plain はプリフライトが飛ばない「単純リクエスト」なので、
       no-cors にする必要がない。通常の cors で投げれば応答を読めるので、
       「届いたが doPost が失敗した」ケースを検出できる。
       cors が通らなかった場合だけ no-cors で投げ直す。 */
    var body = '';
    try {
      payload.ua = cut(payload.ua, 400);
      payload.referrer = cut(payload.referrer, 400);
      payload.value = cut(payload.value, 500);
      body = JSON.stringify(payload);
    } catch (e0) {
      dbg.logVia = 'json-throw';
      dbg.logErr = String(e0 && e0.message ? e0.message : e0);
      return;
    }

    dbg.logAt = stamp();
    dbg.logLen = body.length;
    dbg.logRes = '';
    dbg.logErr = '';
    dbg.logVia = 'cors-sending';

    if (!window.fetch) {
      dbg.logVia = 'no-fetch';
      return;
    }

    var opts = {
      method: 'POST',
      cache: 'no-store',
      redirect: 'follow',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: body
    };

    /* ---- 1) cors（応答が読める） ---- */
    fetch(url, opts).then(function (res) {
      return res.text().then(function (txt) {
        dbg.logRes = cut(txt, 200);
        if (res.ok) {
          dbg.logVia = 'cors-ok';
        } else {
          dbg.logVia = 'cors-status-' + res.status;
        }
      });
    })['catch'](function (e1) {
      /* ---- 2) no-cors で投げ直す（結果は確認できないが届く可能性がある） ---- */
      dbg.logErr = String(e1 && e1.message ? e1.message : e1);
      dbg.logVia = 'cors-failed';
      try {
        var o2 = {
          method: 'POST',
          mode: 'no-cors',
          cache: 'no-store',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: body
        };
        fetch(url, o2).then(function () {
          dbg.logVia = 'nocors-sent';
        })['catch'](function (e2) {
          dbg.logVia = 'nocors-failed';
          dbg.logErr = dbg.logErr + ' / ' + String(e2 && e2.message ? e2.message : e2);
        });
      } catch (e3) {
        dbg.logVia = 'nocors-throw';
      }
    });
  }

  function fire() {
    if (state !== 'idle') return;
    var inp = spellInput();
    var raw = inp ? (inp.value || '') : '';
    var want = answerHash();
    if (!want) { logAttempt(raw, false); start(); return; }
    sha256hex(raw).then(function (got) {
      var ok = !!(got && got === want);
      logAttempt(raw, ok);
      if (ok) {
        var sec = secretSection() || document;
        sec.dispatchEvent(new CustomEvent('mx:spell-correct', {
          bubbles: true,
          detail: { value: raw }
        }));
        return;
      }
      start();
    });
  }

  /* ---------- イベント ---------- */
  document.addEventListener('keydown', function (e) {
    if (state !== 'idle') {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        e.stopImmediatePropagation();
        close('esc');
        return;
      }
      if (state === 'msg') {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          e.stopImmediatePropagation();
          advance();
        }
        return;
      }
      if (state === 'over') {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!overLocked) close('key');
        }
        return;
      }
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      return;
    }

    var t = e.target;
    if (!t || !t.closest) return;
    var sp = t.closest('.mx-spell');
    if (!sp) return;
    var isPen = !!t.closest('.mx-spell__pen');
    var isInput = (t.tagName === 'INPUT');
    if (!isPen && !isInput) return;
    if (e.key !== 'Enter' && !(isPen && (e.key === ' ' || e.key === 'Spacebar'))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fire();
  }, true);

  document.addEventListener('click', function (e) {
    if (state !== 'idle') return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.mx-spell__pen')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fire();
  }, true);

  var rz = null;
  function onResize() {
    if (state === 'idle' || !ov || ov.hidden) return;
    if (rz) clearTimeout(rz);
    rz = setTimeout(function () {
      rz = null;
      if (freezeView) { layoutFrozen(); snapFreezeDiag(); }
      if (reduce()) return;
      sizeCanvas();
      if (state !== 'wipe') fillBlack();
    }, 120);
  }
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && state === 'over') watchTick();
  });

  /* ---------- 事前に 1 つだけ温めておく ---------- */
  function boot() {
    if (!secretSection()) return;
    warmOne();
    var inp = spellInput();
    if (inp) {
      inp.addEventListener('focus', warmOne);
      inp.addEventListener('input', warmOne);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
